var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"bg":"b"}},[_c('p',{staticClass:"annotation text-sm",class:_vm.compCssClasses},[_vm._t("default",[_vm._v(" HERE SOULD BE TEXT ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }